import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';

export const DownloadIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#43494F',
    width: props.width || '20',
    height: props.height || '20',
  };
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11439_4667)">
        <path
          d="M10.0275 15.8333C10.3559 15.8339 10.6812 15.7695 10.9847 15.644C11.2881 15.5184 11.5638 15.3341 11.7958 15.1017L15.0616 11.8333L13.8833 10.6583L10.8558 13.6867L10.8341 0H9.16747L9.18914 13.6733L6.17247 10.6567L4.99414 11.8333L8.25997 15.0992C8.49171 15.3319 8.76715 15.5166 9.07048 15.6426C9.3738 15.7686 9.69902 15.8334 10.0275 15.8333Z"
          fill="white"
        />
        <path
          d="M18.3333 13.3333V17.4999C18.3333 17.7209 18.2455 17.9329 18.0893 18.0892C17.933 18.2455 17.721 18.3333 17.5 18.3333H2.5C2.27899 18.3333 2.06702 18.2455 1.91074 18.0892C1.75446 17.9329 1.66667 17.7209 1.66667 17.4999V13.3333H0V17.4999C0 18.163 0.263392 18.7988 0.732233 19.2677C1.20107 19.7365 1.83696 19.9999 2.5 19.9999H17.5C18.163 19.9999 18.7989 19.7365 19.2678 19.2677C19.7366 18.7988 20 18.163 20 17.4999V13.3333H18.3333Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11439_4667">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
DownloadIcon.iconType = ICON_TYPES.DOWNLOAD_ICON;
